//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ffApplyselect",
  props: {
    value: {
      type: String,
      default: "",
      required: true
    },
    moduid: {
      type: String,
      default: "",
      required: true
    },
    dfieldid: {
      type: String,
      default: "",
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    hasnull: {
      type: Boolean,
      default: false
    },
    selectcode: {
      type: String,
      default: "SYS_CDFCODECONFIG"
    },
    paras: {
      type: Object,
      default: () => ({})
    },
    // 请求应用后端服务标识
    flowsysid: {
      type: String,
      default: "FLOW"
    }
  },
  data() {
    return {
      list: [], //下拉选项
      isShowFlag: true
    };
  },
  created() {
    //获取下拉选项
    this.initSelect();
  },
  watch: {
    moduid: {
      immediate: true,
      handler() {
        if (this.moduid != "") {
          let url = "modu/checkRightlevel";
          let params = {
            pub_moduid: this.moduid,
            flowsysid: this.flowsysid
          };
          this.axios
            .post(url, params)
            .then(({ data }) => {
              if (data.code === "1" && data.data !== "2") {
                this.isShowFlag = false;
              } else {
                this.isShowFlag = true;
              }
            })
            .catch(error => {
              this.isShowFlag = false;
            });
        } else {
          //无权限控制
          this.isShowFlag = false;
        }
      }
    }
  },
  methods: {
    initSelect: async function() {
      let params = [];

      let param = {
        showcode: "list",
        selectcode: this.selectcode,
        hasnull: this.hasnull,
        paras: this.oParas
      };
      params.push(param);

      this.initDropDown(this, params);
    }
  },
  computed: {
    readonly: function() {
      if (this.list === undefined || this.list.length <= 1) {
        //返回true,设为只读
        if (this.list.length === 1) {
          this.$emit("input", this.list[0].propertyValue);
        }

        return true;
      } else {
        this.$emit("input", "");
        return false;
      }
    },
    currentdata: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
      }
    },
    oParas() {
      if (!this.isNotNullOrEmpty(this.paras.paras0)) {
        return { paras0: this.dfieldid, paras1: "1" };
      }

      return this.paras;
    }
  }
};



// WEBPACK FOOTER //
// ./src/pccomponents/ffApplyselect.vue